import { Injectable } from '@angular/core';
import { HapticsService } from './haptics.service';
import { ModalController } from '@ionic/angular';
import { WalletPage } from '../pages/wallet/wallet.page';
import { DateTimeService } from './date-time.service';

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  private activeModal: HTMLIonModalElement | null = null;

  constructor(
    private hapticsService:HapticsService,
    private modalController: ModalController,
    private dateTimeService:DateTimeService
  ) { }

  async checkWallet(initialSegment: 'cards' | 'vouchers' | 'coupons' | 'rewards' = null) {
    
    if(!initialSegment || !['cards','rewards','vouchers','coupons'].includes(initialSegment)) return;

    await this.hapticsService.hapticsImpactLight();
    if(this.activeModal){
      await this.activeModal.dismiss()
    }
    this.activeModal = await this.modalController.create({
      component: WalletPage,
      mode: 'ios',
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      handle: false,
      componentProps: {
        initialSegment,
        today: this.dateTimeService.giveLocalNowDay()
      }
    });
    await this.activeModal.present();
  }
}
